export const BeloppsregleringName = "Beloppsreglering";
export const KortterminalVlName = "Kortterminal VL";
const Names = [BeloppsregleringName, KortterminalVlName] as const;
type ReservedNames = typeof Names[number];

export class PointOfSale {
    id: string;
    name: ReservedNames | string;
    account: string;
}